module.exports = __webpack_public_path__ + "img/section18.941f12b6.png";